var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "users_filter" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            "hide-header": true,
            "no-close-on-backdrop": true,
            dialogClass: "modal-dialog-left modal-lg",
            bodyClass: "p-0",
            size: "xl",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function (ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "xl", variant: "success" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.close_filter()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.__t("PROCESS")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.show_modal,
            callback: function ($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "panel mb-0 border-bottom-0 shadow-none",
              attrs: { id: "panel_prod_list" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
                },
                [
                  _c("h2", [
                    _c("span", { staticClass: "fw-300" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.__t("SELECT_PRODUCT")) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed",
                          on: {
                            click: function ($event) {
                              return _vm.close()
                            },
                          },
                        },
                        [_c("i", { staticClass: "fal fa-times" })]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "panel-container show" }, [
                _c(
                  "div",
                  { staticClass: "panel-content" },
                  [
                    _c(
                      "div",
                      { staticClass: "search_filed" },
                      [
                        _c(
                          "b-input-group",
                          [
                            _c(
                              "b-input-group-text",
                              {
                                attrs: {
                                  slot: "prepend",
                                  placeholder: _vm.__t(
                                    "SEARCH_BY_NAME_CODE_ID"
                                  ),
                                },
                                slot: "prepend",
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.__t("FIND_PRODUCTS")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("b-form-input", {
                              model: {
                                value: _vm.search,
                                callback: function ($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-overlay", { attrs: { show: _vm.is_load } }, [
                      _vm.search_items.length > 0
                        ? _c(
                            "div",
                            { staticClass: "mt-2" },
                            [
                              _c("product_inside_list", {
                                key: "prod_list_in_search",
                                attrs: {
                                  active_ids: _vm.active_ids,
                                  show_remove: false,
                                  show_select: true,
                                  items: _vm.search_items,
                                },
                                on: {
                                  on_prod_select: _vm.on_prod_select,
                                  remove_product: function ($event) {},
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }